// actions.ts
import { Context, IActions } from './actions.types'
import { RootState } from '@/store/types'
import {  Notification, INotification } from '@/entities'
import { ActionTree } from 'vuex';

export const actions: IActions = {

  getFeedbackInfo(context: Context, payload: any): any {
    return this.$services.comment.List(payload)
    .then((data) => {
      context.commit('updateFeedbackInfo', data);
      return data;
    })
    .catch((e) => {
      context.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: e, color: 'error' } as INotification),  { root: true });
    })
  },

  /** create feedback header */
  createFeedbackHeader(context: Context, payload: any): any {
    return this.$services.comment.CreateHeader(payload)
    .then((data) => {
      if(data.Result === 'OK') {
        context.commit('addFeedbackInfo', data.Record);
        return data.Recod;
      } else {
        context.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: data.Message, color: 'error' } as INotification),  { root: true });
      }
    })
  },

  // Get feedback of a thread
  getFeedbacks(context: Context, id: number): any {
    context.commit('markFeedbackRead', id);
    return this.$services.comment.Get(id)
    .then((x) => {
      return x;
    })
  },

  // Resolve the feedback thread
  resolve(context: Context, id: number): any {
    return this.$services.comment.Resolve(id)
    .then((data) => {
      if(data.Result === 'OK') {
        context.commit('setAsResolved', id);
        return true;
      } else {
        context.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: data.Message, color: 'error' } as INotification),  { root: true });
      }
    })
    .catch((e) => {
      context.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: e, color: 'error' } as INotification),  { root: true });
    })
  },

  // Resolve the feedback thread
  reopen(context: Context, id: number): any {
    return this.$services.comment.Reopen(id)
    .then((data) => {
      if(data.Result === 'OK') {
        context.commit('reopen', id);
        return true;
      } else {
        context.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: data.Message, color: 'error' } as INotification),  { root: true });
      }
    })
    .catch((e) => {
      context.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: e, color: 'error' } as INotification),  { root: true });
    })
  },

}